import { Avatar, Paper } from '@mui/material'
import React from 'react'
import LoginForm from '../../Components/views/LoginForm'
import { model } from '../../language/model'
import SensorOccupiedOutlinedIcon from '@mui/icons-material/SensorOccupiedOutlined';
import { useTheme } from '@mui/material/styles';
import './useLoginPage.css'
import BottomBar from '../../Components/views/helperViews/BottomBar/BottomBar';
import { Quotes } from '../../Components';


const LoginPage = () => {


  return (
    <div className='container'>
      <div className='item1'> <LoginShape /> </div>
      <div className='item2'>
         <Quotes />
        <p style={{ textAlign: 'center', fontSize: 'larger', color: '#fff' }}> Application developpe et maintenu par @DaVinci Dynamics</p>
      </div>
      <div className='item3'><BottomBar /></div>
    </div>

  )
}

export default LoginPage


const LoginShape = () => {
  const theme = useTheme()
  return <Paper elevation={3} className="formPaper">
    <p style={{ padding: '10px', textAlign: 'center', fontSize: '25px', fontStyle: 'italic', fontWeight: '700' }}>School Manager</p>
    <div className="loginFromHeader">
      <Avatar className='avatar' sx={{ bgcolor: theme.palette.primary.main, width: '50px', height: '50px' }}>
        <SensorOccupiedOutlinedIcon />
      </Avatar>
      <p className='loginText'>{model.connection}</p>
    </div>
    <LoginForm />
  </Paper>
}






